export default "__VITE_ASSET__BCPnVqvd__"